import { ActionFeedEmptiedMessage } from './ActionFeedEmptiedMessage.component';

export default ActionFeedEmptiedMessage;
